/**
 * Layout: Password
 * -----------------------------------------------------------------------------
 * Entry file for all global password scripts.
 * - All styles are included in critical-password.liquid snippet.
 *
 */
import AppHandler from '~/core/app-handler';
import Bugsnag from '~/core/bugsnag';
import Canvas from '~/core/canvas';
import Commands from '~/core/commands';
import EventBus from '~/core/event-bus';
import { focus, reportError, sleep } from '~/core/global-functions';
import Query from '~/core/query';
import { domReady } from '~/core/runners';
import TagHandler from '~/core/tag-handler';

import Password from '~/templates/password';

/**
 * Global Canvas variables.
 */
window.cnvs = window.cnvs || {};
window.cnvs.started = true;

/**
 * Global Canvas functions.
 */
window.cnvs.EventBus = EventBus();
window.cnvs.Helpers = Commands().cli();
window.cnvs.Query = (query, useCache) => Query(query, useCache);

window.cnvs.Focus = focus;
window.cnvs.ReportError = reportError;
window.cnvs.Sleep = sleep;

/**
 * DOM ready.
 */
domReady(() => {
  Bugsnag().init();
  Commands().init();

  AppHandler().beforeVueInit();
  TagHandler().init();
  Canvas().init();
  AppHandler().afterVueInit();
  Password().init();
});
